import React from 'react';
import { Link } from 'react-router-dom';
import errorImgae from '../../Assets/Images/404.svg';
import './ErrorPage.css';

const ErrorPage = () => {
    return (
        <div className='error-page'>
            <img src={errorImgae} alt="Jahidul Islam Zim" srcset="" />
            <Link to="/" rel="noreferrer"><button class="btn">Go Home <i class="fal fa-home"></i></button></Link>
        </div>
    );
};

export default ErrorPage;